module.exports = __webpack_public_path__ + "static/media/spoon_pan.faf38bd3.svg";